import React from "react";
import ChipContainer from "@hyro-components/ChipContainer";
import PrimitiveCell from "./PrimitiveCell";

const ChipListCell = ({ value, testId = "chip-list-cell", invalidIndexes }) => {
  if (!Array.isArray(value) || value.length === 0) return <PrimitiveCell value={null} />;
  const stringValues = value.map((entry) => (typeof entry === "object" ? JSON.stringify(entry) : String(entry)));
  return <ChipContainer values={stringValues} testId={testId} enableCopy={false} invalidIndexes={invalidIndexes} />;
};

export default ChipListCell;
